import { Box } from '@mui/material';
import { GridColDef, DataGrid, GridToolbar } from '@mui/x-data-grid';
import { WsTypography } from 'wisestep-base';

import { IClientsAnalyticsChartsProps } from '../helper/payloadsAndTypesHelper';
import useGetTopClients from '../Hooks/useGetTopClients';

const TopClientsTable = ({ clientsAnalyticsChartsProps }: IClientsAnalyticsChartsProps) => {
  let sum = 0;
  const paginationSize = 10;
  const data = useGetTopClients(clientsAnalyticsChartsProps);

  const tableData: Record<string, unknown>[] = [];

  data?.map((item) => {
    tableData.push({
      id: item.clientName,
      placements: item.placements,
    });
    sum += item.placements;
  });

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'Client Name', flex: 2 },
    {
      field: 'placements',
      headerName: `Total OrderBook (${sum})`,
      flex: 1,
    },
  ];

  return (
    <Box height="100%" width="100%">
      <WsTypography bold={true}>{'Current Year Top 20 Clients'}</WsTypography>
      <Box mt={1} style={{ height: 670 }}>
        <DataGrid
          columns={columns}
          rows={tableData}
          components={{ Toolbar: GridToolbar }}
          pageSize={paginationSize}
          rowsPerPageOptions={[paginationSize]}
        />
      </Box>
    </Box>
  );
};

export default TopClientsTable;
